import React from 'react';
import VehicleTrackingMap from '../components/VehicleTrackingMap';

const VehicleTrackingPage: React.FC = () => {
  return <VehicleTrackingMap isWidget={false} />;
};

export default VehicleTrackingPage;
